import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { WhyKodaGroup } from './components/WhyKodaGroup';
import { ServiceAreas } from './components/ServiceAreas';
import { Contact } from './components/Contact';
import { InsightsSection } from './components/InsightsSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Services data-id="element-3" />
      <About data-id="element-4" />
      <WhyKodaGroup data-id="element-5" />
      <ServiceAreas data-id="element-6" />
      <Contact data-id="element-7" />
      <InsightsSection data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}